/* eslint-disable jsx-a11y/anchor-is-valid */
/* eslint-disable jsx-a11y/alt-text */
import React, { Component, Fragment } from 'react';
import { shopContext } from '../../contexts/aniplus';
import { withRouter } from 'react-router-dom';
import axios from 'axios';
// import HTMLEllipsis from "react-lines-ellipsis/lib/html";
import parse from 'html-react-parser';

// import SumSex from "./SumSex";
// import SumAge from "./SumAge";

import moment from 'moment';
import { Modal } from 'react-responsive-modal';
import UsePoint from '../point/UsePoint';
// import LiveInfo from "./LiveInfo";
import LiveInfoNew from './LiveInfoNew';
// import TvInfo from "./TvInfo";
import TvInfoNew from './TvInfoNew';
// import TimelineInfo from "./TimelineInfo";

import { toast } from 'react-toastify'; //토스트(toast)
// import { confirmAlert } from "react-confirm-alert"; //알럿창(alert confirm)
import ReactPlayer from 'react-player';
//import Popup from "reactjs-popup";
import { isMobile } from 'react-device-detect';
import { Base64 } from 'js-base64';

// const _keyStr = "C012V45c6ky89AbdeBDFxHGIKwzLNrOPMST*UW-XZa7fgEhijJlnQRo3pYqstuvm_";

class ItemInfo extends Component {
  state = {
    modalShow: false,
    payGubun: '',
    pvShow: false,
    pvUrl: '',
    existLive: false,
    existTv: false,
    more: false,
    timeMenu: 'live',
  };
  _isMounted = false;
  componentDidMount = () => {
    const { serviceEndDate } = this.props;
    this._isMounted = true;
    this._getData(this.props.childProps.contentSerial);
    if (moment(new Date()).format('YYYY-MM-DD HH:mm:ss') > serviceEndDate) {
      this._timeMenu('tv');
    }
  };
  componentWillUnmount = () => {
    this._isMounted = false;
  };

  UNSAFE_componentWillReceiveProps = (nextProps, nextState) => {
    //console.log(this.props.location.pathname)
    //console.log(nextProps.location)
    return (
      this.props.childProps.contentSerial !== nextProps.childProps.contentSerial
    );
    //return true;
  };
  componentWillReceiveProps = (nextProps) => {
    ////console.log(nextProps)
    //console.log(this.props.childProps.contentSerial, nextProps.childProps.contentSerial)

    if (
      this.props.childProps.contentSerial !== nextProps.childProps.contentSerial
    ) {
      this._getData(nextProps.childProps.contentSerial);
    }
  };

  _getData = async (contentSerial) => {
    const { onContentGubun, onTitle, setVideo } = this.props.childProps;

    if (
      contentSerial === '' ||
      contentSerial === null ||
      contentSerial === undefined
    ) {
      alert('잘못된 경로 또는 URL입니다.');
    } else {
      //window.scrollTo(0, 0)
      const result = await this._getDataApi(contentSerial);
      const intReturn = result.data[0].intReturn;
      const contentInfo = result.data[0].listData;

      if (intReturn === 0) {
        if (this._isMounted) {
          this.setState({
            contentInfo: contentInfo[0],
            contentPartSerial: contentInfo[0].contentPartSerial,
            subPartSerial2: contentInfo[0].subPartSerial2,
            subPartSerial3: contentInfo[0].subPartSerial3,
            part: contentInfo[0].part,
          });
          onTitle(
            contentInfo[0].title,
            contentInfo[0].imageL,
            contentInfo[0].synopsis
          );
          onContentGubun(contentInfo[0].gubun);
          setVideo(
            contentInfo[0].opening,
            contentInfo[0].ending,
            contentInfo[0].pv
          );
        }
      }
    }
  };

  _getDataApi = (contentSerial) => {
    const { apiUrl } = this.props;
    //const { contentSerial } = this.props.childProps;
    ////console.log(apiUrl + '/itemInfo?contentSerial=' + contentSerial)

    return axios(apiUrl + '/itemInfo?contentSerial=' + contentSerial)
      .then((response) => response)
      .catch((error) => {
        alert('작품 데이터를 로드 중 오류가 발생했습니다.');
      });
  };
  _onBuyDownload = () => {
    const { buyDownload } = this.props.childProps;
    buyDownload();
  };

  _onBuyVod = () => {
    const { buyVod } = this.props.childProps;
    buyVod();
  };
  _onPlay = async () => {
    console.log('itemInfo click.');

    const { loginId, setPlayUrl, aParam, serviceEndDate } = this.props;
    const { contentPartSerial, subPartSerial2, subPartSerial3, part } =
      this.state;
    //const { contentPartSerial, subPartSerial2, subPartSerial3, part } = contentInfo;

    if (moment(new Date()).format('YYYY-MM-DD HH:mm:ss') > serviceEndDate) {
      alert('VOD 서비스가 종료되었습니다.');
      return null;
    }

    if (loginId === '' || loginId === null || loginId === undefined) {
      //alert('로그인 후 이용이 가능합니다.')
      toast.warn('로그인 후 이용이 가능합니다.');
    } else {
      //console.log(subPartSerial2)
      if (
        subPartSerial2 === '' ||
        subPartSerial2 === null ||
        subPartSerial2 === undefined ||
        subPartSerial2 === 0
      ) {
        toast.warn('파라메터가 누락되었습니다.');
        //alert('파라메터가 누락되었습니다.')
      } else {
        //이용권, 포인트 체크
        const date = new Date();
        const timeStemp = moment(date)
          .add(10, 'minutes')
          .format('YYYYMMDDHHmmss');
        //let param = this.encode(timeStemp)

        //let crypParam = timeStemp + '|aniplus|' + subPartSerial2 + '/' + loginId
        let crypParam =
          timeStemp + '|was|' + subPartSerial2 + '/' + loginId + '@' + aParam;
        const base64Data = await this._getBase64Encode(crypParam);
        crypParam = base64Data.data.codeString;

        let urlEncode =
          contentPartSerial +
          '|' +
          subPartSerial2 +
          '|' +
          subPartSerial3 +
          '|' +
          part;
        const base64Data1 = await this._getBase64Encode(urlEncode);
        urlEncode = base64Data1.data.codeString;

        const result = await this._onPlayApi(subPartSerial2, crypParam);
        if (result) {
          const intReturn = result.data[0].intReturn;
          //console.log(intReturn)
          if (intReturn === 0 || intReturn === 10) {
            //onCloseModal()
            setPlayUrl(urlEncode);
            //history.push('/player/?u=' + urlEncode)
          } else if (intReturn === -7 || intReturn === -1) {
            toast.error('서비스 중인 콘텐츠가 아닙니다.');
            //alert('서비스 중인 콘텐츠가 아닙니다.')
          } else if (intReturn === -4 || intReturn === -5) {
            //alert('이용권 또는 포인트 구매 후 관람이 가능합니다.')
            toast.error('이용권 또는 포인트 충전 후 관람이 가능합니다.');
          } else if (intReturn === -2) {
            toast.error('19세 미만은 관람이 불가한 작품입니다');
            //alert('19세 미만은 관람이 불가한 작품입니다.')
          } else if (intReturn === -3) {
            //alert('포인트결제')
            this._onShowModal('vod');
          } else {
            toast.error('오류가 발생했습니다.');
            //alert('오류가 발생했습니다.')
          }
        }
      }
    }
  };
  getCookie = (name) => {
    var value = document.cookie.match('(^|;) ?' + name + '=([^;]*)(;|$)');

    return value ? value[2] : null;
  };
  _onPlayApi = (subPartSerial, crypParam) => {
    const { apiUrl, loginId, authId, history } = this.props;
    // const at = localStorage.getItem('at');
    const at = this.getCookie('at');
    let token = new Date();
    token = moment(token).format('YYYYMMDDhhmmss');
    token = Base64.encode(token);
    console.log('------- iteminfo --------');
    return axios
      .post(
        apiUrl + '/vodUrl',
        {
          params: {
            userid: loginId,
            authId: authId,
            subPartSerial: subPartSerial,
            //param: param,
            crypParam: crypParam,
            token: token,
          },
        },
        {
          headers: {
            Authorization: 'bearer ' + at,
          },
        }
      )
      .then((response) => response)
      .catch((error) => {
        //alert('오류가 발생했습니다.')
        if (error.response.status === 403) {
          //console.log('refresh....token...')
          this._refreshToken(0);
        } else if (error.response.status === 400) {
          history.push('/login');
        }
      });
  };
  _refreshToken = async (gubun) => {
    const { history, apiUrl, setLoginId, setAuthId, loginId } = this.props;
    // const rt = localStorage.getItem('rt');
    const rt = this.getCookie('rt');
    if (rt === '' || rt === undefined || rt === null) {
      history.push('/login');
      return false;
    }

    const { data } = await axios.post(apiUrl + '/refreshToken', {
      params: {
        rt: rt,
        userid: loginId,
      },
    });

    if (data[0].intReturn === 0) {
      //console.log(data[0].at)
      localStorage.setItem('at', data[0].at);
      if (gubun === 0) {
        this._onPlay();
      } else if (gubun === 1) {
        this._setPointUse();
      }
    } else {
      this.setCookie('account', '');

      setLoginId('');
      setAuthId('');

      setTimeout(() => {
        history.push('/login');
      }, 500);
    }
  };
  setCookie = (name, value, exp) => {
    let expires;
    if (exp) {
      var date = new Date();
      date.setTime(date.getTime() + exp * 24 * 60 * 60 * 1000);
      expires = date.toGMTString();
    } else {
      expires = '';
    }
    document.cookie =
      name +
      '=' +
      value +
      ';expires=' +
      expires +
      ';path=/; SameSite=None; Secure; domain=aniplustv.com';
  };
  _setPointUse = async () => {
    const { loginId } = this.props;
    const { payGubun } = this.state;

    if (loginId === null || loginId === undefined || loginId === '') {
    } else {
      const result = await this._setPointUseApi();
      if (result) {
        const intReturn = result.data[0].intReturn;
        if (intReturn === 0) {
          this.setState({
            modalShow: false,
          });
          if (payGubun === 'down') {
            this._onDownload();
          } else {
            this._onPlay();
          }

          ////console.log('다운로드 시작.')
        }
      }
    }
  };
  _setPointUseApi = () => {
    const { payGubun } = this.state;
    const { contentSerial, subPartSerial2 } = this.props.childProps;

    const { apiUrl, loginId, authId, history } = this.props;
    const at = this.getCookie('at');
    // const at = localStorage.getItem('at');

    //console.log(apiUrl + '/setUsePoint?userid=' + loginId + '&CheckedItems=' + subPartSerial2 + ',' + '&contentSerial=' + contentSerial + '&gubun=' + payGubun )
    //return axios(apiUrl + '/setUsePoint?userid=' + loginId + '&CheckedItems=' + subPartSerial2 + ',' + '&contentSerial=' + contentSerial + '&gubun=' + payGubun + '&chksale=ppv' )
    return axios
      .post(
        apiUrl + '/setUsePoint',
        {
          params: {
            userid: loginId,
            authId: authId,
            CheckedItems: subPartSerial2 + ',',
            contentSerial: contentSerial,
            gubun: payGubun,
            chksale: 'ppv',
          },
        },
        {
          headers: {
            Authorization: 'bearer ' + at,
          },
        }
      )
      .then((response) => response)
      .catch((error) => {
        //toast.error('포인트 정보를 로드중 오류가 발생했습니다.')
        //alert('포인트 정보를 로드중 오류가 발생했습니다.')
        if (error.response.status === 403) {
          //console.log('refresh....token...')
          this._refreshToken(1);
        } else if (error.response.status === 400) {
          history.push('/login');
        }
      });
  };
  _getBase64Encode = (codeString) => {
    const { aspUrl, pkg, loginId } = this.props;
    return axios(
      aspUrl +
        '/base64encode_wd.asp?codeString=' +
        codeString +
        '&p=' +
        pkg +
        '&i=' +
        loginId
    )
      .then((response) => response)
      .catch((error) => {
        //console.log('error...')
      });
  };
  _getBase64Decode = (codeString) => {
    const { aspUrl } = this.props;
    //console.log(aspUrl + '/base64decode.asp?codeString=' + codeString)
    return axios(aspUrl + '/base64decode.asp?codeString=' + codeString)
      .then((response) => response)
      .catch((error) => {
        //console.log('error...')
      });
  };
  _onShowModal = (payGubun) => {
    //alert(0)
    this.setState({
      payGubun: payGubun,
      modalShow: true,
    });
  };
  _onCloseModal = () => {
    this.setState({
      modalShow: false,
    });
  };
  _onPlayPv = (url) => {
    this.setState({
      pvShow: true,
      pvUrl: url,
    });
  };
  _onClosePv = () => {
    this.setState({
      pvShow: false,
      pvUrl: '',
    });
  };
  _zoomIn = () => {
    this.setState({
      zoom: true,
    });
  };
  _zoomOut = () => {
    this.setState({
      zoom: false,
    });
  };
  _existLive = (val) => {
    //console.log(val)
    this.setState({
      existLive: val,
    });
  };

  _existTv = (val) => {
    //console.log(val)
    this.setState({
      existTv: val,
    });
  };
  _onLiveTime = () => {
    const { setTimeline, setTvline, setContentSerial } = this.props;
    setTimeline(true);
    setTvline(false);
    setContentSerial(0);
  };

  _onTvTime = () => {
    const { setTimeline, setTvline, setContentSerial } = this.props;
    setTimeline(false);
    setTvline(true);
    setContentSerial(0);
  };
  _more = () => {
    const { more } = this.state;

    this.setState({
      more: !more,
    });
  };
  _timeMenu = (timeMenu) => {
    this.setState({
      timeMenu,
    });
  };
  _director = () => {
    const { onDirector } = this.props.childProps;
    onDirector();
  };
  _raftel = (url) => {
    window.open(url, '', '');
  };

  render() {
    const {
      contentInfo,
      payGubun,
      modalShow,
      contentPartSerial,
      subPartSerial2,
      subPartSerial3,
      pvShow,
      pvUrl,
      zoom,
      existLive,
      existTv,
      more,
      timeMenu,
    } = this.state;
    const { contentSerial, alram, toggleAlram } = this.props.childProps;
    const { imgUrl, serviceEndDate } = this.props;
    return (
      <Fragment>
        {contentInfo ? (
          <div className="detil_top">
            <div className="logo_div">
              <img src={contentInfo.imageLO} />
            </div>
            {/* <div className="ranking_div">
              <span>
                <strong>
                  {contentInfo.rank > 100 ? '100' : contentInfo.rank}
                </strong>
                {contentInfo.rank > 100 ? '+' : '위'}
              </span>
            </div> */}

            <div className="baner live_detail">
              <div className="float_left">
                {contentInfo.gubun === 2 ? (
                  <span>
                    <img src={imgUrl + '/img/detail_img/airing_icon.png'} />
                  </span>
                ) : null}
                <div>
                  <img src={contentInfo.imageL} />
                  <em style={{ cursor: 'pointer' }} onClick={this._zoomIn}>
                    더보기
                  </em>
                </div>
              </div>

              <div className="float_right">
                <h1>
                  {contentInfo.title}
                  <span>{contentInfo.otitle}</span>
                </h1>
                <ul>
                  <li>
                    <span>감독</span>
                    <em>
                      {/* <a href="#director" style={{ color: "#ff5d24" }}> */}
                      {contentInfo.director}
                      {/* </a> */}
                    </em>
                  </li>
                  <li>
                    <span>장르</span>
                    <em>
                      {/* <a href="#genre" style={{ color: "#ff5d24" }}> */}
                      {contentInfo.genreName}
                      {/* </a> */}
                    </em>
                  </li>
                  <li>
                    <span>제작</span>
                    <strong>
                      {/* <a href="#production" style={{ color: "#ff5d24" }}> */}
                      {contentInfo.production}
                      {/* </a> */}
                    </strong>
                  </li>
                  <li>
                    <span>화수</span>
                    <strong>
                      {contentInfo.number === 0
                        ? '미공개'
                        : contentInfo.number + '화'}
                    </strong>
                  </li>
                  <li>
                    <span>등급</span>
                    <strong>{contentInfo.restrictionCode}세 관람</strong>
                  </li>
                  <li>
                    <span>방영</span>
                    <strong>
                      {contentInfo.makeYear === 0
                        ? '미정'
                        : contentInfo.makeYear.substr(4, 2) === '01'
                        ? contentInfo.makeYear.substr(0, 4) + '년 1분기'
                        : contentInfo.makeYear.substr(4, 2) === '04'
                        ? contentInfo.makeYear.substr(0, 4) + '년 2분기'
                        : contentInfo.makeYear.substr(4, 2) === '07'
                        ? contentInfo.makeYear.substr(0, 4) + '년 3분기'
                        : contentInfo.makeYear.substr(4, 2) === '10'
                        ? contentInfo.makeYear.substr(0, 4) + '년 4분기'
                        : ''}
                    </strong>
                  </li>
                  <li>
                    <span>편성</span>
                    <strong>{contentInfo.comment}</strong>
                  </li>
                  <li>
                    <span>영상</span>
                    {contentInfo.opening === '' ||
                    contentInfo.opening === null ||
                    contentInfo.opening === undefined ? null : (
                      <em
                        onClick={() => this._onPlayPv(contentInfo.opening)}
                        style={{ cursor: 'pointer' }}
                      >
                        Opening MV
                      </em>
                    )}
                    {contentInfo.ending === '' ||
                    contentInfo.ending === null ||
                    contentInfo.ending === undefined ? null : (
                      <em
                        onClick={() => this._onPlayPv(contentInfo.ending)}
                        style={{ cursor: 'pointer' }}
                      >
                        Ending MV
                      </em>
                    )}
                    {contentInfo.pv === '' ||
                    contentInfo.pv === null ||
                    contentInfo.pv === undefined ? null : (
                      <em
                        onClick={() => this._onPlayPv(contentInfo.pv)}
                        style={{ cursor: 'pointer' }}
                      >
                        PV
                      </em>
                    )}
                  </li>
                </ul>
                <div className="summary_text">
                  <h2>줄거리</h2>
                  {contentInfo.synopsis === '' ||
                  contentInfo.synopsis === null ||
                  contentInfo.synopsis === undefined
                    ? null
                    : parse(contentInfo.synopsis)}
                  {/* {contentInfo.synopsis === '' ||
                  contentInfo.synopsis === null ||
                  contentInfo.synopsis === undefined
                    ? null
                    : contentInfo.synopsis.length > 130
                    ? more
                      ? parse(contentInfo.synopsis)
                      : parse(contentInfo.synopsis.substr(0, 130))
                    : parse(contentInfo.synopsis)}
                  {contentInfo.synopsis === '' ||
                  contentInfo.synopsis === null ||
                  contentInfo.synopsis === undefined ? null : contentInfo
                      .synopsis.length > 130 ? (
                    more ? (
                      <span>
                        <a style={{ cursor: 'pointer' }} onClick={this._more}>
                          접기
                        </a>
                      </span>
                    ) : (
                      <span>
                        <a style={{ cursor: 'pointer' }} onClick={this._more}>
                          더보기
                        </a>
                      </span>
                    )
                  ) : null} */}
                </div>

                {/* 라이브 티비 편성표 변경*/}

                <div
                  className="timeline_wrap"
                  style={{ display: existLive || existTv ? '' : 'none' }}
                >
                  <div className="tab_menu">
                    {moment(new Date()).format('YYYY-MM-DD HH:mm:ss') >
                    serviceEndDate ? null : (
                      <button
                        type="button"
                        onClick={() => this._timeMenu('live')}
                        className={timeMenu === 'live' ? 'active' : null}
                      >
                        <b>LIVE</b>
                      </button>
                    )}

                    <button
                      type="button"
                      onClick={() => this._timeMenu('tv')}
                      className={timeMenu === 'tv' ? 'active' : null}
                    >
                      <b>TV</b>
                    </button>
                  </div>

                  {timeMenu === 'live' ? (
                    moment(new Date()).format('YYYY-MM-DD HH:mm:ss') >
                    serviceEndDate ? null : (
                      <LiveInfoNew
                        contentSerial={contentSerial}
                        existLive={this._existLive}
                        alram={alram}
                        toggleAlram={toggleAlram}
                      />
                    )
                  ) : (
                    <TvInfoNew
                      contentSerial={contentSerial}
                      existTv={this._existTv}
                    />
                  )}
                </div>
                {moment(new Date()).format('YYYY-MM-DD HH:mm:ss') >
                serviceEndDate ? (
                  contentInfo.laftel === '' ? null : (
                    <div className="timeline_wrap">
                      <img src="/img/ico_raftel.svg" />
                      <span
                        style={{
                          color: '#fff',
                          paddingLeft: 10,
                          fontSize: 14,
                          cursor: 'pointer',
                        }}
                        onClick={() => this._raftel(contentInfo.laftel)}
                      >
                        라프텔에서 관람하기
                      </span>
                    </div>
                  )
                ) : null}
              </div>
            </div>
          </div>
        ) : null}
        <Modal
          open={modalShow}
          showCloseIcon={false}
          onClose={this._onCloseModal}
          closeOnOverlayClick={false}
          closeOnEsc={false}
          center
          styles={{ modal: { backgroundColor: 'black' } }}
        >
          <UsePoint
            contentSerial={contentSerial}
            contentPartSerial={contentPartSerial}
            subPartSerial2={subPartSerial2 + ','}
            subPartSerial3={subPartSerial3}
            payGubun={payGubun}
            chksale="ppv"
            onPointUse={this._setPointUse}
            onClose={this._onCloseModal}
          />
        </Modal>
        <Modal
          open={pvShow}
          showCloseIcon={false}
          onClose={this._onClosePv}
          closeOnOverlayClick={true}
          closeOnEsc={true}
          center
          styles={{ modal: { backgroundColor: 'black' } }}
        >
          <ReactPlayer
            url={pvUrl}
            playing
            controls
            width={isMobile ? 320 : 640}
          />
        </Modal>
        <Modal
          open={zoom}
          showCloseIcon={false}
          onClose={this._zoomOut}
          closeOnOverlayClick={true}
          closeOnEsc={true}
          center
          styles={{ modal: { backgroundColor: 'black' } }}
        >
          <div>
            <div
              style={{ cursor: 'pointer', color: '#ffffff', padding: 5 }}
              onClick={this._zoomOut}
            >
              close X
            </div>
            <div>
              <img
                src={contentInfo ? contentInfo.imageL : null}
                style={{ width: '100%' }}
              />
            </div>
          </div>
        </Modal>
        {/*
                <div>
                   {
                       contentInfo ? (
                       <div>{ contentInfo.title}</div>
                       ) : null
                   }
                </div>
                */}
        {/*            
                <ToastContainer 
                    position="bottom-right"
                    hideProgressBar
                />
                */}
      </Fragment>
    );
  }
}

export default shopContext(withRouter(ItemInfo));
